import { LitElement, html, broadcastReceiver } from '@hh/global.js'

class ProductUseItWith extends LitElement {
  constructor() {
    super();
  }

  connectedCallback() {
    super.connectedCallback()

    setTimeout(() => {
      this.fetchProducts()
    }, 0)

    this.receiver = broadcastReceiver('modal', (...args) => {
      this.fetchProducts()
    })
  }

  disconnectedCallback() {
    super.disconnectedCallback()
    this.receiver.disconnect()
  }

  fetchProducts() {
    fetch(this.dataset.url)
      .then(response => response.text())
      .then(text => {
        const html = document.createElement('div');
        html.innerHTML = text;
        const recommendations = html.querySelector('product-use-it-with');
        if (recommendations && recommendations.innerHTML.trim().length) {
          this.innerHTML = recommendations.innerHTML;
        }
      })
      .catch(e => {
        console.error(e);
      });
  }

  render() {
    return html`<slot></slot>`
  }
}

customElements.define('product-use-it-with', ProductUseItWith);
